module.exports = __webpack_public_path__ + "static/media/TbSettingsDollarDisabled.e5d59ec1.svg";